import { AxiosGet } from '../../http/Axios';

const GetFamilyGuid = async (email) => {
  if (!email) {
    console.error('Email is missing or undefined in GetFamilyGuid');
    return;
  }

  try {
    return await AxiosGet(`/kidlab-reg/families/guid?email=${encodeURIComponent(email)}`);
  } catch (error) {
    console.error('Error fetching GUID:', error);
    throw error;
  }
};

export default GetFamilyGuid;
